module.exports = __webpack_public_path__ + "media/images/emblems/Lufingen-blazon-2c04dad439d2117c438347876cd658c2.svg";